import interact from "interactjs";

var interactions = {
  dragDrop(container, handleElement, GlobalX, GlobalY) {
    interact(container)
    .draggable({
      modifiers: [
        interact.modifiers.snap({
          targets: [interact.createSnapGrid({ x: 30, y: 30 })],
          range: Infinity,
          relativePoints: [{ x: 0, y: 0 }]
        }),
        interact.modifiers.restrict({
          restriction: document.getElementById("app"),
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        })
      ],
      inertia: true,
      allowFrom: handleElement,
      preventOnFilter: false
    })
    .on("dragmove", function(event) {
      GlobalX += event.dx;
      GlobalY += event.dy;

      event.target.style.webkitTransform = event.target.style.transform =
        "translate(" + GlobalX + "px, " + GlobalY + "px)";
    })
    .on("down", function(event) {
      let underneath = document.getElementsByClassName("menuBlock");
      underneath.forEach(function(obj, i){
        obj.style.zIndex = "100";
      });
      document.querySelector(container).style.zIndex = "10005";
    })

  },

  dragDropResize(container, handleElement, resizeElement, GlobalX, GlobalY, ratioLock) {
    interact(container)
    .resizable({
      // resize from all edges and corners
      edges: { left: true, right: true, bottom: true, top: false },

      listeners: {
        move(event) {
          var target = event.target;

          let reSizeTarget = document.querySelector(resizeElement);
          let topBarHeight = 30;

          // update the element's style
          reSizeTarget.style.width = event.rect.width + "px";
          reSizeTarget.style.height = (event.rect.height - (topBarHeight + 5)) + "px";

          // translate when resizing from top or left edges
          GlobalX += event.deltaRect.left;
          GlobalY += event.deltaRect.top;

          target.style.webkitTransform = target.style.transform =
            "translate(" + GlobalX + "px," + GlobalY + "px)";

          target.setAttribute("data-x", GlobalX);
          target.setAttribute("data-y", GlobalY);
        }
      },
      modifiers: [
        // keep the edges inside the parent
        interact.modifiers.restrictEdges({
          outer: document.getElementById("app")
        }),

        // minimum size
        interact.modifiers.restrictSize({
          min: { width: 200, height: 0 }
        }),

        // a ternary hack to only have aspectRatio preserved when lockRatio === true
        // if lockRatio === false, the interact.modifiers.restrictSize definition is repeated since the ternary needs a value2
        (ratioLock ? interact.modifiers.aspectRatio({ratio: "preserve"}): interact.modifiers.restrictSize({min: { width: 200, height: 0 }}))
      ],

      inertia: true,
      preventOnFilter: false
    })
    .draggable({
      modifiers: [
        interact.modifiers.snap({
          targets: [interact.createSnapGrid({ x: 30, y: 30 })],
          range: Infinity,
          relativePoints: [{ x: 0, y: 0 }]
        }),
        interact.modifiers.restrict({
          restriction: document.getElementById("app"),
          elementRect: { top: 0, left: 0, bottom: 1, right: 1 }
        })
      ],
      inertia: true,
      allowFrom: handleElement,
      preventOnFilter: false
    })
    .on("dragmove", function(event) {
      GlobalX += event.dx;
      GlobalY += event.dy;

      event.target.style.webkitTransform = event.target.style.transform =
        "translate(" + GlobalX + "px, " + GlobalY + "px)";
    })
    .on("down", function(event) {
      let underneath = document.getElementsByClassName("menuBlock");
      underneath.forEach(function(obj, i){
        obj.style.zIndex = "100";
      });
      document.querySelector(container).style.zIndex = "10005";
    })
  },

  enableFold(handle, content, foldBool) {
    const delta = 6;
    let startX;
    let startY;

    let contentEl = document.querySelector(content);
    
    let foldsize = "0px";

    if (foldBool == true) {
      contentEl.style.height = foldsize;
      contentEl.style.width = "200px";
      } else {
        contentEl.style.height = "250px"
      }

    document.querySelector(handle).addEventListener("mousedown", function(event) {
      startX = event.pageX;
      startY = event.pageY;
    });

    document.querySelector(handle).addEventListener("mouseup", function(event) {
      const diffX = Math.abs(event.pageX - startX);
      const diffY = Math.abs(event.pageY - startY);

      contentEl.scrollTo(0, contentEl.scrollHeight);

      if (diffX < delta && diffY < delta) {
        if (foldBool == false || contentEl.offsetHeight > 10) {
          this.formerheight = contentEl.offsetHeight;
          contentEl.style.height = foldsize;
          contentEl.style.width = "200px";
          foldBool = true;
        } else {
          contentEl.style.height = "auto";
          foldBool = false;
        }
      }
    });
  }

}

export default interactions